import styled from 'styled-components'

import HashLoader from "react-spinners/HashLoader"

export const Container = styled.div` 
  width: 100%;
  height: 100%;
  min-height: 120px;
  padding: 12px;
  display: flex;
  align-items: center;
  justify-content: center; 
  background-color: ${({ theme }) => theme.colors.background};
`;

// Spinner sempre aparece sobre o bege (tela cheia na BusinessData, no lugar
// da lista de horarios na SchedulingAdd), logo usa o acento de PAGINA, nao
// o de superficie. Mesma escolha do ServiceList do beuddy, que passa
// `theme.colors.theme.accent` para o Loading dele.
export const Spinner = styled(HashLoader).attrs(({ theme }) => ({
  color: theme.colors.accent
}))`

`
